import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";

// Auth
import Login from "./pages/Login";
import Register from "./pages/Register";

// Dashboard
import Overview from "./pages/Overview";
import Monitoring from "./pages/Monitoring";
import Inbox from "./pages/Inbox";
import Analytics from "./pages/Analytics";

// Content sources
import Links from "./pages/content/Links";
import Files from "./pages/content/Files";
import RawContent from "./pages/content/RawContent";
import NotionContent from "./pages/content/NotionContent";
import YoutubeContent from "./pages/content/YoutubeContent";
import ConfluenceContent from "./pages/content/ConfluenceContent";
import ZendeskContent from "./pages/content/ZendeskContent";

// Customisation
import Appearance from "./pages/customisation/Appearance";

// Advanced
import Settings from "./pages/advanced/Settings";

// Leads & Integrations
import Leads from "./pages/leads/Leads";
import Integrations from "./pages/integrations/Integrations";

// Chatbot
import Chatbot from "./pages/Chatbot";
import Demo from "./pages/Demo";
import Billing from "./pages/Billing";
import CreateChatbot from "./pages/chatbot/create";
import ChatbotRedirect from "./components/ChatbotRedirect";
import ChatbotDemo from "./components/ChatBox";
import ProtectedRoute from "./components/ProtectedRoute";

// Profile
import UpdateProfile from "./pages/UpdateProfile";

// Team
import Team from "./pages/team/Team";

import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* App */}
          <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/chatbot" replace />} />

            {/* Chatbot switcher */}
            <Route path="chatbot" element={<ChatbotRedirect />} />

            {/* Dashboard */}
            <Route path="overview/:chatbotId" element={<Overview />} />
            <Route path="monitoring/:chatbotId" element={<Monitoring />} />
            <Route path="inbox/:chatbotId" element={<Inbox />} />
            <Route path="analytics/:chatbotId" element={<Analytics />} />

            {/* Sources */}
            <Route path="sources/website/:chatbotId" element={<Links />} />
            <Route path="sources/files/:chatbotId" element={<Files />} />
            <Route path="sources/raw/:chatbotId" element={<RawContent />} />
            <Route path="sources/notion/:chatbotId" element={<NotionContent />} />
            <Route path="sources/youtube/:chatbotId" element={<YoutubeContent />} />
            <Route path="sources/confluence/:chatbotId" element={<ConfluenceContent />} />
            <Route path="sources/zendesk/:chatbotId" element={<ZendeskContent />} />

            {/* Customisation */}
            <Route path="customisation/appearance/:chatbotId" element={<Appearance />} />

            {/* Leads */}
            <Route path="leads/:chatbotId" element={<Leads />} />

            {/* Integrations */}
            <Route path="integrations/:chatbotId" element={<Integrations />} />

            {/* Advanced */}
            <Route path="advanced/settings/:chatbotId" element={<Settings />} />

            {/* Top-level */}
            <Route path="chatbots" element={<Chatbot />} />
            <Route path="chatbot/create" element={<CreateChatbot />} />
            <Route path="chatbot/demo" element={<ChatbotDemo />} />
            <Route path="demo" element={<Demo />} />
            <Route path="billing" element={<Billing />} />
            <Route path="profile" element={<UpdateProfile />} />
            <Route path="team" element={<Team />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/chatbot" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
